export type Step = 1 | 2 | 3 | 4 | 5;

/** Pay now or pay later: the review's two buttons answer it (a car that allows pay later), and the booking is made that way. */
export type PayChoice = "now" | "later";

/**
 * The booking's steps, in order, in ONE place (1NOW-11173): the phone's sheet and the desktop's pages both
 * read their labels, titles and address names from here, so the two cannot drift apart. `key` is the step's
 * name in the address (`?step=details`), which is also what any pageview-based tracking sees.
 */
export const STEP_DEFS = [
  {
    key: "details",
    /** In the desktop stepper. */
    label: "Driver details",
    /** In the phone's narrow progress row. */
    short: "Details",
    title: "Who will drive?",
    note: "The name must match the driver's licence.",
  },
  {
    key: "protection",
    label: "Protection",
    short: "Protection",
    title: "Which protection do you need?",
    note: "Pick one. You can change it until you pay.",
  },
  {
    key: "extras",
    label: "Extras",
    short: "Extras",
    title: "Which extras do you need?",
    note: "Optional. Prices are per day or per trip.",
  },
  {
    key: "review",
    label: "Review",
    short: "Review",
    title: "Review your booking",
    note: "Check everything, then book.",
  },
  {
    key: "pay",
    label: "Pay",
    short: "Pay",
    title: "Payment",
    note: "Accept the agreement and policies, then pay by card to confirm the car.",
  },
] as const;

export const STEP_KEYS = STEP_DEFS.map((d) => d.key);

const at = (key: (typeof STEP_KEYS)[number]) => (STEP_KEYS.indexOf(key) + 1) as Step;
/** The steps the flow's rules are about, by name: the booking is made leaving REVIEW, and PAY is where it is accepted and paid. */
export const EXTRAS = at("extras");
export const REVIEW = at("review");
export const PAY = at("pay");
